import { ApiError, type ApiClient } from '@fusapp-work/api'
import { z } from 'zod'
import { parseResponse } from '../../features/organization/shared/response'

const count = z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER).nullable()
export const navigationSummarySchema = z.object({
  organization: z.object({ id: z.string().min(1), companies: count, audit: count }),
  cosmos: z.object({ users: count, roles: count, managedChannels: count, templates: count, permanentErrorTransactions: count,
    draftWelcomeScreens: count }),
  asOf: z.iso.datetime({ offset: true }),
})
export type NavigationSummary = z.infer<typeof navigationSummarySchema>

export function createNavigationSummaryApi(client: ApiClient) {
  return {
    async get(organizationId: string, signal?: AbortSignal): Promise<NavigationSummary> {
      const id = z.string().min(1).parse(organizationId)
      const query = new URLSearchParams({ organizationId: id })
      const value = parseResponse(navigationSummarySchema, await client.request<unknown>(`/api/v1/console/navigation/summary?${query}`, { signal }))
      if (value.organization.id !== id) throw new ApiError('Invalid navigation summary scope', 200, 'INVALID_RESPONSE')
      return value
    },
  }
}
